/** Niveles de acceso a dashboards concedidos (extensible en fase grupos). */
export const DASHBOARD_ACCESS_LEVELS = {
  view: {
    label: 'Solo lectura',
    readOnly: true,
    chipColor: 'info',
  },
  edit: {
    label: 'Edición',
    readOnly: false,
    chipColor: 'success',
  },
};

export function resolveDashboardAccessLevel(dashboard) {
  if (!dashboard) return null;
  if (dashboard.accessLevel) return String(dashboard.accessLevel);
  if (dashboard.grantedAccess || dashboard.readOnly) return 'view';
  return null;
}

export function dashboardAccessMeta(dashboardOrLevel) {
  const input =
    dashboardOrLevel && typeof dashboardOrLevel === 'object'
      ? dashboardOrLevel
      : dashboardOrLevel
        ? { accessLevel: dashboardOrLevel }
        : null;
  const level = resolveDashboardAccessLevel(input);
  if (!level) {
    return {
      level: null,
      label: null,
      readOnly: false,
      isGranted: false,
      chipColor: 'default',
    };
  }
  const def = DASHBOARD_ACCESS_LEVELS[level] || DASHBOARD_ACCESS_LEVELS.view;
  return {
    level,
    label: def.label,
    readOnly: def.readOnly,
    isGranted: true,
    chipColor: def.chipColor,
  };
}

export function isDashboardReadOnly(dashboardOrLevel) {
  return dashboardAccessMeta(dashboardOrLevel).readOnly;
}

export function isGrantedDashboard(dashboardOrLevel) {
  return dashboardAccessMeta(dashboardOrLevel).isGranted;
}

export function normalizeManagerGrants(list) {
  return (list || [])
    .map((item) => {
      if (item != null && typeof item === 'object') {
        const dashboardId = Number(item.dashboardId);
        if (!Number.isFinite(dashboardId)) return null;
        return {
          dashboardId,
          accessLevel: item.accessLevel === 'edit' ? 'edit' : 'view',
        };
      }
      const dashboardId = Number(item);
      if (!Number.isFinite(dashboardId)) return null;
      return { dashboardId, accessLevel: 'view' };
    })
    .filter(Boolean);
}

export function managerHasGrant(grants, dashboardId) {
  const id = Number(dashboardId);
  return normalizeManagerGrants(grants).some((g) => g.dashboardId === id);
}

export function getManagerGrantLevel(grants, dashboardId) {
  const id = Number(dashboardId);
  const row = normalizeManagerGrants(grants).find((g) => g.dashboardId === id);
  return row?.accessLevel || 'view';
}

export function buildGroupTree(groups) {
  const byParent = new Map();
  for (const g of groups || []) {
    const pid = g.parentGroupId != null ? String(g.parentGroupId) : 'root';
    if (!byParent.has(pid)) byParent.set(pid, []);
    byParent.get(pid).push(g);
  }
  for (const rows of byParent.values()) {
    rows.sort((a, b) => String(a.name).localeCompare(String(b.name)));
  }
  const walk = (parentKey, depth) => {
    const nodes = byParent.get(parentKey) || [];
    return nodes.flatMap((g) => [
      { ...g, depth },
      ...walk(String(g.id), depth + 1),
    ]);
  };
  return walk('root', 0);
}
